<template>
  <div class="cp-set-theme-color main" :key="z">
    <div class="divider" />
    <div class="row">
      <p><i class="fa fa-palette icon" />Theme Color</p>
      <div class="value">Choose a theme color</div>
      <div style="margin-top: 10px; margin-left: 32px">
        <div class="field has-addons">
          <p class="control is-expanded">
            <input class="input" v-model="color" placeholder="#1c37bd" />
          </p>
          <p class="control">
            <a
              v-if="validColor"
              class="button has-text-grey"
              @click="previewColor"
            >
              Preview
            </a>
            <a v-else class="button has-text-grey" @click="hexColorInfo">
              Hex Color
            </a>
          </p>
        </div>
      </div>
      <div class="save-wrapper">
        <swatches
          class="swatches"
          v-model="color"
          swatch-size="36"
          :trigger-style="{
            width: '200px',
            height: '36px',
            border: '1px solid #ddd',
          }"
          popover-to="right"
          @close="previewColor"
        />
        <p v-if="updatingColor" class="button">
          <i class="fa fa-spinner fa-spin" />
        </p>
        <p v-else class="button has-text-success" @click="saveThemeColor">
          Save
        </p>
      </div>
    </div>
  </div>
</template>


<script>
import Swatches from "vue-swatches";
import "vue-swatches/dist/vue-swatches.min.css"; // Import the styles too, globally

export default {
  name: "CPSetThemeColor",
  components: { Swatches },
  props: {
    b: Object,
  },
  data() {
    return {
      z: 0,
      color: null,
      updatingColor: false,
      iosIdx: 0,
      iosArray: ["black-translucent", "white", "black", "default"],
    };
  },
  computed: {
    business() {
      return this.b;
      // return this.$store.state.selectedBusiness;
    },
    commerce() {
      if (!this.business || !this.business.workflows) return null;
      return this.business.workflows.find((w) => w.name === "Commerce");
    },
    validColor() {
      return (
        this.color && this.color.length === 7 && this.color.startsWith("#")
      );
    },
    iosStyle() {
      var idx = this.iosIdx % 4;
      return this.iosArray[idx];
    },
  },
  mounted() {
    this.color = this.business.data.theme_color;
  },
  methods: {
    hexColorInfo() {
      var msg = "Enter a hex color code<br>e.g. #5959ab (7-characters)";
      this.errorToast(msg, "bottom", 8000);
    },
    testIOS() {
      this.iosIdx += 1;
      var str = "meta[name=apple-mobile-web-app-status-bar-style]";
      var appleThemeColor = document.querySelector(str);
      appleThemeColor.setAttribute("content", this.iosStyle);
    },
    previewColor() {
      this.testIOS();
      document.querySelector("meta[name='theme-color']").content = this.color;
      this.$emit("preview", this.color);
    },
    saveThemeColor() {
      this.previewColor();
      if (!this.validColor) {
        this.hexColorInfo();
        return;
      }
      var obj = { theme_color: this.color };
      this.updatingColor = true;
      this.$store
        .dispatch("updateBusiness", {
          id: this.business.id,
          data: obj,
        })
        .then(() => {
          this.successToast("Updated!");
          // this.business.data = res.data.data; //obj;
          // this.updateCommerceHome();
          this.refreshBusiness();
        })
        .catch((err) => this.apiError(err))
        .finally(() => (this.updatingColor = false));
    },
    refreshBusiness() {
      this.$store
        .dispatch("getAndSelectBusiness", this.business.id)
        .then(() => {
          this.z += 1;
          setTimeout(() => this.goto("/commerce_home"), 800);
        })
        .catch((err) => this.apiError(err));
    },
    updateCommerceHome() {
      this.$store
        .dispatch("getAndSelectBusiness", this.business.id)
        .catch((err) => this.apiError(err));
      this.$store
        .dispatch("getWorkflows", this.businessID)
        .catch((err) => this.apiError(err));

      setTimeout(() => this.goto("/commerce_home"), 800);
    },
  },
};
</script>

<style scoped>
.main {
  height: 100%;
}
.divider {
  height: 8px;
}
.row {
  background-color: white;
  padding: 8px;
}
.icon {
  color: grey;
  width: 24px;
  margin-right: 8px;
  padding-top: 4px;
  text-align: center;
}
.value {
  color: grey;
  margin-left: 32px;
  /* border-bottom: 1px dotted rgb(230, 230, 230); */
}
.save-wrapper {
  margin-top: 10px;
  text-align: right;
}
.theme-color {
  height: 30px;
  border-radius: 2px;
  margin-left: 32px;
  margin-top: 4px;
  margin-bottom: 4px;
  box-shadow: 0 0 1px 1px lightgrey;
}
.swatches {
  float: left;
  /* display: inline-block; */
  /* border: 2px black solid; */
  /* border-radius: 35%; */
  height: 38px;
  margin-right: 12px;
  margin-left: 32px;
  /* filter: drop-shadow(1px solid rgb(107, 95, 95)); */
}
</style>
